import Typography from '@/components/next-ui/Typography';
import { cx } from 'cva';
import { isEmpty, throttle } from 'lodash-es';
import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdOutlineCloudUpload } from 'react-icons/md';
import ImageCarousel from '../ImageCarousel';
import { useBreakpointHooks } from '@/utils/break-points.provider';

const fileSizeLimit = {
  size: 1024 * 1024 * 10, // 10MB
  message: 'File size should be less than 10MB',
};

function PostImageSelector(props) {
  const {
    onChange,
    value = [],
    maxFiles = 10,
    autoOpen = false, //TODO: Temporary
    dropBoxMessage = null,
  } = props;
  const [rejectedFiles, setRejectedFiles] = React.useState([]);

  const isLessThanSmallScreen = useBreakpointHooks((bp) => bp.useSmaller('sm'));

  const updateSelectedImages = (images) => {
    const allImages = [...(value || []), ...images];
    onChange(allImages);
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: 'image/*',
    multiple: true,
    maxSize: fileSizeLimit.size,
    maxFiles: maxFiles,
    onDrop: (accepted, rejected) => {
      if (accepted.length > 0) {
        updateSelectedImages(
          accepted.map((v) =>
            Object.assign(v, {
              preview: URL.createObjectURL(v),
            }),
          ),
        );
      } else if (rejected.length > 0) {
        setRejectedFiles(rejected);
      }
    },
  });

  const autoOpenFileDialog = useCallback(
    throttle(() => {
      setTimeout(() => {
        open();
      }, 100);
    }, 5000),
    [],
  );

  useEffect(() => {
    // updateSelectedImages([]);
    if (autoOpen) {
      autoOpenFileDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cx(
        'flex h-full w-full flex-col items-start justify-center gap-3',
        isLessThanSmallScreen ? 'flex-9-1-0' : 'flex-1',
      )}>
      <div
        className={cx(
          'flex w-full flex-col items-center justify-start rounded-md bg-primary-light-1 p-8',
          isDragActive && 'shadow-md',
        )}
        {...getRootProps()}>
        <input {...getInputProps()} name="imageFile" />
        <MdOutlineCloudUpload className="h-12 w-12 text-primary" />
        <Typography variant="h4" className="mt-4">
          {dropBoxMessage || 'Drop your files here or click to select files'}
        </Typography>
      </div>

      {!isEmpty(value) && <ImageCarousel images={value} onChange={onChange} />}
    </div>
  );
}

export default PostImageSelector;
